import {
  AcfGalleryImageType,
  AcfImageProps,
  AcfImageType,
} from "@talladega/types";

/**
 * Utility function to determine if the given image follows the "node" structure.
 * This is necessary to handle variations in ACF plugin versions, where image data
 * may either be nested within a "node" property or provided directly.
 * Ensures compatibility when packaging and sharing ACF components across projects.
 */
export function IsNodeStructure(
  image: AcfImageType | AcfGalleryImageType | undefined
): image is { node: AcfImageProps } {
  if (!image) {
    return false;
  }
  return "node" in image;
}

export default {};
